<mat-accordion [multi]="multi">
  <mat-expansion-panel *ngFor="let model of responseModels" [expanded]="expanded">
    <mat-expansion-panel-header>
      <mat-panel-title title="{{ model.label }}">
        <div class="modelLabel ellipsis">
          {{ model.label }}
        </div>
        <div class="modelResponseButtonZone">
          <span *ngIf="model.linkType !== LinkTypeEnumeration.NO_LINK || model.attachments.length">
            <knowledge-base-attachment [currentDocument]="model"></knowledge-base-attachment>
          </span>
          <button
            mat-icon-button
            (click)="copyPaste(model, $event)"
            class="cng-ico_inserer_txt"
            [disabled]="!canCopyPaste"
            type="button"
            title="{{ 'agent:contact.mailactions.buttonInsertKnowledge' | translate }}"
          ></button>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="description" [innerHTML]="model.content"></div>
  </mat-expansion-panel>
</mat-accordion>
